import http from './request'

const api = {
    index: {
        dashboard: {
            statistics: async function (params = {}) {
                return await http.getAsync('/agent/dashboard/statistics', params)
            }
        }
    },
    login: async function (params = {}) {
        return await http.postAsync('/agent/login', params)
    },
    // 登录图形验证码
    loginCaptcha: async function () {
        return await http.postAsync('/agent/login/captcha')
    },
    uploadImage: function (params = {}, header) {
        return http.post('/agent/merchants/upload', params, header)
    },
    uploadImageOnlyUrl: function (params = {}, header) {
        return http.post('/agent/upload', params, header)
    },
    ocrDiscern: function (params = {}, header) {
        return http.post('/agent/upload/ocr-discern', params, header)
    },
    banks: {
        branchBanks: function (params = {}) {
            return http.get('/agent/branch_banks', params)
        },
        list: function (params = {}) {
            return http.get('/agent/banks', params)
        }
    },
    merchant: {
        list: async function (params = {}) {
            return await http.getAsync('/agent/merchants', params)
        },
        create: async function (params = {}) {
            return await http.postAsync('/agent/merchants', params)
        },
        edit: async function (id, params = {}) {
            return await http.postAsync('/agent/merchants/' + id, params)
        },
        select: async function (id, params = {}) {
            return await http.getAsync('/agent/merchants/' + id, params)
        },
        income: {
            applyProto: async function (params = {}) {
                return await http.postAsync('/agent/merchants/apply_agreement', params)
            },
            selectEcNo: async function (params = {}) {
                return await http.getAsync('/agent/merchants/get_ec_no', params)
            },
            confirmMaterial: async function (params = {}) {
                return await http.postAsync('/agent/merchants/confirmMaterial', params)
            },
            auth: async function (params = {}) {
                return await http.getAsync('/agent/merchants/auth', params)
            },

            /** 进件 */
            incoming: async function (params = {}) {
                return await http.postAsync('/agent/merchants/incoming', params)
            },
            /**重新提交 */
            againIncoming: async function (params = {}) {
                return await http.postAsync('/agent/merchants/again-incoming', params)
            },
            /**费率修改 */
            changeMerchantRate: async function (params = {}) {
                return await http.postAsync('/agent/merchants/change-merchant-rate', params)
            },
            /**修改商户通道资料 */
            changeMerchantInfo: async function (params = {}) {
                return await http.postAsync('/agent/merchants/change-merchant-info', params)
            },
            /**修改商户结算信息 */
            changeMerchantSettlement: async function (params = {}) {
                return await http.postAsync('/agent/merchants/change-merchant-settlement', params)
            },
        },
        merchantChange: async function (params = {}) {
            return await http.postAsync('/agent/merchants/change', params)
        },
        channel: {
            channel: async function (id, params = {}) {
                return await http.getAsync('/agent/merchants/' + id + '/payment_channels?id=' + id, params)
            },
            payConfig: async function (params = {}) {
                return await http.getAsync('/agent/merchants/pay_config', params)
            },
            deletePaymentChannels: async function (id, params = {}) {
                return await http.postAsync('/agent/merchants/' + id + '/delete_payment_channels', params)
            },
            savePaymentChannels: async function (id, params = {}) {
                return await http.postAsync('/agent/merchants/' + id + '/add_payment_channels', params)
            },
            editPaymentChannels: async function (id, params = {}) {
                return await http.postAsync('/agent/merchants/' + id + '/edit_payment_channels', params)
            },
            changePaymentChannelAutoOpen: async function (params = {}) {
                return await http.postAsync('/agent/merchants/edit_payment_channels/auto_open', params)
            },
        },
        store: {
            list: async function (params = {}) {
                return await http.getAsync('/agent/stores', params)
            },
            add: async function (params = {}) {
                return await http.postAsync('/agent/stores', params)
            },
            edit: async function (id, params = {}) {
                return await http.putAsync('/agent/stores/' + id, params)
            },
            cashRegisterList: async function (params = {}) {
                return await http.getAsync('/agent/codelist', params)
            },
            cashierCodeList: async function (params = {}) {
                return await http.getAsync('/agent/cashiers', params)
            },
            addCashierCode: async function (params = {}) {
                return await http.postAsync('/agent/addcode', params)
            }
        },
        cashier: {
            list: async function (params = {}) {
                return await http.getAsync('/agent/cashiers', params)
            },
            add: async function (params = {}) {
                return await http.postAsync('/agent/cashiers', params)
            },
            edit: async function (id, params = {}) {
                return await http.putAsync('/agent/cashiers/' + id, params)
            },
            delete: async function (id, params = {}) {
                return await http.deleteAsync('/agent/cashiers/' + id, params)
            }
        },
        device: {
            list: async function (url, params = {}) {
                return await http.getAsync(url, params)
            },
            deviceCategory: async function (params = {}) {
                return await http.getAsync('/agent/device_categories', params)
            },
            bindStore: async function (id, params) {
                return await http.postAsync('/agent/devices/' + id + '/bind_store', params)
            },
            unBindStore: async function (id, params = {}) {
                return await http.postAsync('agent/merchants/' + id + '/un_bind_devices', params)
            },
            unBindDeviceList: async function (params = {}) {
                return await http.getAsync('/agent/devices', params)
            },
            bindDevices: async function (id, params) {
                return await http.postAsync('/agent/merchants/' + id + '/bind_devices', params)
            }
        },
        activity: {
            list: async function (params = {}) {
                return await http.getAsync('/agent/merchant/preferential/activity-list', params)
            },
            register: async function (merchantId, params = {}) {
                return await http.postAsync('/agent/merchant/preferential/' + merchantId + '/activity-register', params)
            },
            requestedRegister: async function (merchantId, params = {}) {
                return await http.getAsync('/agent/merchant/preferential/' + merchantId + '/requested-activity-list', params)
            },
            requestedActivityStatus: async function (merchantId, params = {}) {
                return await http.getAsync('/agent/merchant/preferential/' + merchantId + '/status-select', params)
            },
            setActivityRates: async function (merchantId, params = {}) {
                return await http.postAsync('/agent/merchant/preferential/' + merchantId + '/rate-update', params)
            }
        }
    },
    salesman: {
        list: async function (params = {}) {
            return await http.getAsync('/agent/salesmen', params)
        },
        add: async function (params = {}) {
            return await http.postAsync('/agent/salesmen', params)
        },
        edit: async function (id, params = {}) {
            return await http.putAsync('/agent/salesmen/' + id, params)
        },
        del: async function (id) {
            return await http.deleteAsync('/agent/salesmen/' + id)
        },
        statistical: async function (params = {}) {
            return await http.getAsync('/agent/salesman/statistical', params)
        },
        export: function (params = {}, filename) {
            return http.download('/agent/salesman/statistics_export', params, filename)
        },
        levelAgentSalesman: async function (params = {}) {
            return await http.getAsync('/agent/salesman/list', params)
        },
    },
    agent: {
        list: async function (params = {}) {
            return await http.getAsync('/agent/agents', params)
        },
        getOne: async function (id, params = {}) {
            return await http.getAsync('/agent/agents/' + id, params)
        },
        addAgent: async function (params = {}) {
            return await http.postAsync('/agent/agents', params)
        },
        editAgent: async function (id, params = {}) {
            return await http.putAsync('/agent/agents/' + id, params)
        },
        delete: async function (id, params = {}) {
            return await http.deleteAsync('/agent/agents/' + id, params)
        },
        device: {
            list: async function (id, params = {}) {
                return await http.getAsync('/agent/agents/' + id + '/devices', params)
            },
            unBindDeviceList: async function (params = {}) {
                return await http.getAsync('/agent/devices', params)
            },
            bindDevices: async function (id, params) {
                return await http.postAsync('/agent/agents/' + id + '/bind_devices', params)
            },
            unBindDevices: async function (id, params) {
                return await http.postAsync('/agent/agents/' + id + '/un_bind_devices', params)
            },
        },
        rate: {
            saveRate: async function (id, params) {
                return await http.postAsync('/agent/agents/' + id + '/rate', params)
            },
        },
        profit: {
            list: async function (params = {}) {
                return await http.getAsync('/agent/agents/profit/statistics', params)
            },
            subordinateAgentsData: async function (params = {}) {
                return await http.getAsync('/agent/agents/profit/subordinate_agents_data', params)
            },
            export: function (params = {}, filename) {
                return http.download('/agent/agents/profit/statistics_export', params, filename)
            },
        },
        levelAgents: {
            list: async function (params = {}) {
                return await http.getAsync('/agent/agents/level-agents', params)
            },
        }
    },
    channel: {
        paymentChannels: async function (params = {}) {
            return await http.getAsync('/agent/payment_channels', params)
        }
    },
    mcc: {
        list: function (params = {}) {
            return http.get('/agent/mccs', params)
        }
    },
    order: {
        list: async function (params = {}) {
            return await http.getAsync('/agent/orders', params)
        },
        details: async function (params = {}) {
            return await http.getAsync('/agent/orders/detail', params)
        },
        refund: {
            list: async function (params = {}) {
                return await http.getAsync('/agent/orders/refund/list', params)
            },
            details: async function (params = {}) {
                return await http.getAsync('/agent/orders/refund/details', params)
            },
        },
        statistics: {
            merchantStatisticsCollect: async function (params = {}) {
                return await http.getAsync('/agent/orders/merchant-statistics-collect', params)
            },
            merchantStatistics: async function (params = {}) {
                return await http.getAsync('/agent/orders/merchant-statistics', params)
            },
            export: function (params = {}, filename) {
                return http.download('/agent/orders/merchant-statistics-export', params, filename)
            },
            merchantOrderDetailCollect: function (params = {}) {
                return http.getAsync('/agent/orders-collect', params)
            },
            merchantList: function (params = {}) {
                return http.getAsync('/agent/orders/statistic/list', params)
            },
            merchantListCollect: function (params = {}) {
                return http.getAsync('/agent/orders/statistic/collect', params)
            },
        }

    },
    device: {
        list: async function (params = {}) {
            return await http.getAsync('/agent/devices', params)
        },
    },
    invoice: {
        record: async function (params = {}) {
            return await http.getAsync('/agent/invoice/billing_record', params)
        },
        apply: async function (params = {}) {
            return await http.postAsync('/agent/invoice/apply_invoicing', params)
        },
    },
    ad: {
        add: async function (params = {}) {
            return await http.postAsync('/agent/advertisement', params)
        },
        edit: async function (params = {}) {
            return await http.postAsync('/agent/advertisement/update', params)
        },
        del: async function (params = {}) {
            return await http.postAsync('/agent/advertisement/delete', params)
        },
        list: async function (params = {}) {
            return await http.getAsync('/agent/advertisement/list', params)
        },
    },
    settlement: {
        record: async function (params = {}) {
            return await http.getAsync('/agent/settlement_record', params)
        },
        agent: function (params = {}) {
            return http.getAsync('/agent/settlement', params)
        },
        salesman: function (params = {}) {
            return http.getAsync('/agent/salesman', params)
        },
    },
    business: {
        list: async function (params = {}) {
            return await http.postAsync('/agent/lakala_business_scope', params)
        },
    },
    address: {
        list: async function (params = {}) {
            return await http.postAsync('/agent/lakala_address_all', params)
        },
        search: async function (params = {}) {
            return await http.postAsync('/agent/lakala_address', params)
        },
    }
}

export default api
